// extracted by mini-css-extract-plugin
export default {"main_sec":"styles_main_sec__v6L8w","tabContent":"styles_tabContent__reyUW","button":"styles_button__mORas"};